/**
 * google-auth — entrar con Google (mismo Firebase Auth del OS).
 *
 * Firebase se carga recién al tocar el botón: quien entra con link o contraseña no baja nada de esto.
 * Se usa solo para que Google confirme quién es la persona: el ID token va al backend (POST /auth/google) y el portal
 * sigue con su propia sesión. Por eso se cierra la sesión de Firebase enseguida.
 */
let _auth = null;

async function cargarAuth() {
  if (_auth) return _auth;
  const [{ initializeApp, getApps }, fb] = await Promise.all([import("firebase/app"), import("firebase/auth")]);
  const app = getApps()[0] || initializeApp({
    apiKey:            import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain:        import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId:         import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket:     import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId:             import.meta.env.VITE_FIREBASE_APP_ID,
  });
  _auth = { auth: fb.getAuth(app), fb };
  return _auth;
}

/** Abre la ventana de Google y devuelve el ID token. Devuelve null si la persona cierra la ventana. Lanza Error con un mensaje claro si falla. */
export async function idTokenDeGoogle() {
  if (!import.meta.env.VITE_FIREBASE_API_KEY) throw new Error("Entrar con Google no está disponible en este momento.");
  const { auth, fb } = await cargarAuth();
  const provider = new fb.GoogleAuthProvider();
  provider.setCustomParameters({ prompt: "select_account" });      // deja elegir la cuenta (puede ser la del equipo o una personal)
  try {
    const cred = await fb.signInWithPopup(auth, provider);
    const token = await cred.user.getIdToken();
    await fb.signOut(auth).catch(() => {});
    return token;
  } catch (e) {
    const c = e?.code || "";
    if (c === "auth/popup-closed-by-user" || c === "auth/cancelled-popup-request") return null;
    if (c === "auth/popup-blocked") throw new Error("Tu navegador bloqueó la ventana de Google. Permitila y probá de nuevo.");
    if (c === "auth/unauthorized-domain") throw new Error("Entrar con Google todavía no está habilitado en esta dirección. Usá tu link por mail o tu contraseña.");
    if (c === "auth/network-request-failed") throw new Error("Sin conexión. Revisá tu internet y probá de nuevo.");
    throw new Error("No pudimos entrar con Google. Probá de nuevo.");
  }
}
